import { render, staticRenderFns } from "./RegisterFormDetails.vue?vue&type=template&id=e51913c8&scoped=true"
import script from "./RegisterFormDetails.vue?vue&type=script&lang=js"
export * from "./RegisterFormDetails.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormDetails.vue?vue&type=style&index=0&id=e51913c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51913c8",
  null
  
)

export default component.exports